<!--
 * @Author: your name
 * @Date: 2021-12-28 15:26:11
 * @LastEditTime: 2022-01-10 13:56:54
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \petro-web-chemicals-sellerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\mine\personal\SetUp.vue
-->
<template>
  <div class="set-up">
    <Header title="设置" :is-nav="true"></Header>
    <div class="container-bo">
      <van-cell title="登录密码修改" is-link to="/updatePassword" />
    </div>
    <div class="container-bo">
      <van-cell title="手机号修改" is-link to="/updatePhoneNumber" />
    </div>

    <div class="container-bo">
      <div class="exit" @click="exit">退出登录</div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
export default {
  components: {
    Header,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    exit() {
      this.$dialog
        .alert({
          title: "登录退出",
          message: "确认退出登录吗？",
        })
        .then(() => {
          // this.$store.commit("logout");
          this.$router.push("/login");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.set-up {
  .container-bo {
    margin-top: 10px;
    .van-cell__title, .van-cell__right-icon {
      height: 70px;
      line-height: 70px;
      font-size: 32px;
    }
    .exit {
      height: 80px;
      line-height: 80px;
      font-size: 32px;
      background: #fff;
      text-align: center;
    }
  }
}
</style>
